var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackingMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.116,
    height: 17.881,
    viewBox: "0 0 20.116 17.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracking",
    d: "M10.058,0A4.19,4.19,0,0,0,5.867,4.191c0,1.69.589,2.162,3.761,6.758a.524.524,0,0,0,.861,0c3.169-4.6,3.76-5.067,3.76-6.758A4.19,4.19,0,0,0,10.058,0Zm0,6.147A1.676,1.676,0,1,1,11.734,4.47,1.677,1.677,0,0,1,10.058,6.147ZM.351,7.949A.557.557,0,0,0,0,8.465v8.853a.56.56,0,0,0,.768.518l4.819-2.191V7.034a6.9,6.9,0,0,1-.58-1.184Zm11.055,3.639a1.641,1.641,0,0,1-2.7,0c-.564-.818-1.831-2.623-2-2.868v6.9l6.705,2.267V8.717C13.239,8.961,11.972,10.767,11.406,11.588ZM19.351,5.63,14.528,7.823V17.881l5.235-2.36A.591.591,0,0,0,20.116,15V6.147A.545.545,0,0,0,19.351,5.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingMenuIcon);
export default __webpack_public_path__ + "static/media/TrackingMenuIcon.ecdca48061516177830318fa88bd1a27.svg";
export { ForwardRef as ReactComponent };